import { render, staticRenderFns } from "./short-course.vue?vue&type=template&id=73f46e19&scoped=true&"
import script from "./short-course.vue?vue&type=script&lang=js&"
export * from "./short-course.vue?vue&type=script&lang=js&"
import style0 from "./short-course.vue?vue&type=style&index=0&id=73f46e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f46e19",
  null
  
)

export default component.exports